import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BarChart3 } from "lucide-react";
import LanguageSwitcher from "./LanguageSwitcher";
import SoundToggle from "./SoundToggle";
import DemoHealthBadge from "./DemoHealthBadge";

function Navbar({ user, onLogout }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLogout = () => {
    onLogout();
    navigate("/");
  };

  const showAnalytics = user?.role === "educator" || user?.role === "admin";

  return (
    <nav className="navbar px-3 sm:px-6 py-4">
      <div className="container mx-auto flex items-center justify-between gap-2">
        <div 
          className="flex items-center gap-2 sm:gap-3 cursor-pointer min-w-0 flex-1 sm:flex-initial"
          onClick={() => navigate("/dashboard")}
          data-testid="nav-logo"
        >
          <img 
            src="/assets/lsbp-logo.png"
            alt="Lemonade Stand Business Plan Logo"
            className="h-10 sm:h-12 flex-shrink-0"
          />
          <div className="hidden sm:block min-w-0">
            <h1 className="text-xl font-bold text-white truncate">Lemonade Stand Business Plan</h1>
            <p className="text-xs text-white/80">Business Plan</p>
          </div>
        </div>

        <div className="flex items-center gap-1 sm:gap-3 flex-shrink-0">
          {/* Demo Health Badge - Admins only */}
          {user?.role === "admin" && <DemoHealthBadge />}

          {/* Analytics Button - Educators & Admins only */}
          {showAnalytics && (
            <button
              onClick={() => navigate("/analytics")}
              className="flex items-center gap-2 text-white hover:bg-white/10 px-3 py-2 rounded-lg transition-colors"
              data-testid="analytics-link"
              title={t('nav.analytics', 'Analytics')}
            >
              <BarChart3 className="w-5 h-5" />
              <span className="hidden md:inline text-sm font-medium">{t('nav.analytics', 'Analytics')}</span>
            </button>
          )}
          
          {/* Sound Toggle */}
          <SoundToggle className="hidden sm:block" />
          
          <LanguageSwitcher />
          <button
            onClick={() => navigate("/profile")}
            className="flex items-center gap-2 text-white hover:bg-white/10 px-2 sm:px-3 py-2 rounded-lg transition-colors"
            data-testid="profile-link"
          >
            {user.avatar_url ? (
              <img src={user.avatar_url} alt="Avatar" className="w-8 h-8 rounded-full" />
            ) : (
              <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center text-white font-bold">
                {user.name.charAt(0).toUpperCase()}
              </div>
            )}
            <div className="text-left hidden sm:block">
              <div className="text-white font-semibold text-sm" data-testid="nav-user-name">{user.name}</div>
              <div className="text-xs text-white/80 capitalize">{t(`roles.${user.role}`)}</div>
            </div>
          </button>
          <button
            onClick={handleLogout}
            className="bg-white text-yellow-600 px-3 sm:px-4 py-2 rounded-lg font-semibold hover:bg-yellow-50 transition-colors text-sm sm:text-base"
            data-testid="logout-btn"
          >
            {t('nav.logout')}
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
